import { Component, OnInit ,AfterViewInit, ElementRef} from '@angular/core';
import { AppConstant } from 'src/app/app.constants';
import { CommonLookupData } from 'src/app/shared/commonHelper/common.service';
import { ToastrService } from 'ngx-toastr';
import * as powerbiClient from 'powerbi-client';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})

export class UserDashboardComponent implements OnInit, AfterViewInit {
  safeSrc: SafeResourceUrl;
  constructor(public _appConstant: AppConstant, private _commonLookupData: CommonLookupData, private _toasterService: ToastrService,private sanitizer: DomSanitizer) {
   }
  private AccessToken: string = "";
  private ReportId: string = "";
  private tileId: string = "";
  private ReportGroupId: string = "";
  private reportUrl: string="";
  private reportType: string="";
  public reportHeight: number = window.innerHeight - 192;
  public IsPowerBIReport : boolean = true;
  public DashboardReportUrl : string = "";

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.LoadDashoardReport();
  }

  LoadDashoardReport() {
    this._commonLookupData.GetToken((accessToken: any) => {
      if (accessToken != false) {
        this.AccessToken = accessToken;
        this.getUserDashboardReport();
      } else {
        this._toasterService.error("Something went wrong, Please contact technical support or administration.", 'Error');
      }
    });
  };

  getUserDashboardReport() {
    this._commonLookupData.getUserDashboardReport((result: any) => {
      if (result && result.isSuccess && result.data) {
        if (result.data.isPowerBIReport && this.CheckReportUrl(result.data.dashboardReportUrl)) {
          this.showReports();
        }
        else
        {
          this.IsPowerBIReport = result.data.isPowerBIReport;
          this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(result.data.dashboardReportUrl);

        }
      }
      // else {
      //   this._toasterService.error("Dashboard report not configure.", 'Error');
      // }
    });
  };

  showReports() {
    this.reportHeight = window.innerHeight - 221;
    const config : powerbiClient.IEmbedConfiguration= {
      type: this.reportType,
      accessToken: this.AccessToken,
      embedUrl: this.reportUrl,
      uniqueId: this.ReportId,
      permissions: powerbiClient.models.Permissions.All,
      viewMode: powerbiClient.models.ViewMode.View,
      pageView: 'actualSize',
      id:this.tileId,
      dashboardId:this.ReportId,
      settings:{filterPaneEnabled:true, navContentPaneEnabled:true}
    };

    let myDiv1 = document.getElementById('userReportsContainer');
    if (myDiv1 != null) {
      const powerbi = new powerbiClient.service.Service(
        powerbiClient.factories.hpmFactory,
        powerbiClient.factories.wpmpFactory,
        powerbiClient.factories.routerFactory
      );
      powerbi.reset(myDiv1);
      powerbi.embed(myDiv1, config);
    }
  };

  CheckReportUrl(url: string) {
    if (url) {
      var urlArray = url.split('/');
      if (urlArray.length >= 7 && urlArray[4] && urlArray[6]) {
        this.ReportId = urlArray[6].toString();
        this.ReportGroupId = urlArray[4].toString();
        if(urlArray[7]=="tiles")
        {
          this.reportType="tile";
          this.tileId=urlArray[8].toString();
          this.reportUrl=this._appConstant.powerbiTileURl + this.ReportId +'&tileId='+ urlArray[8].toString() +'&groupId=' + this.ReportGroupId;
        }
        else if(urlArray[5]=="dashboards")
        {
          this.tileId='';
          this.reportType=this._appConstant.powerBiDashboard;
          this.reportUrl=this._appConstant.powerbiDashboardURl + this.ReportId + '&groupId=' + this.ReportGroupId;
        }
        else if(urlArray[5]=="reports"){
          this.tileId='';
          this.reportType=this._appConstant.powerBiReport;
          this.reportUrl=this._appConstant.powerbiReportURl + this.ReportId + '&groupId=' + this.ReportGroupId;
        }
        return true;
      } else {
        this._toasterService.error("PowerBI URL not in proper format.", 'Error');
        return false;
      }
    } else {
      return false;
    }
  };
}
